import React, { useEffect, useState, Fragment, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Switch from "@material-ui/core/Switch";
import AdminView from "./AdminView";
import Reports from "./Reports";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import NormalText from "../../general/NormalText";
import { OrangeButton } from "../../general/OrangeButton";
import { ZoomIn, ZoomOut } from "@material-ui/icons";
import { Dropdown } from "react-bootstrap";

import Typography from "@material-ui/core/Typography";
import "./dashboard.css";
// import {
//   KeyboardDatePicker,
//   MuiPickersUtilsProvider,
// } from "@material-ui/pickers";
import * as theme from "../../theme";
import Select from "react-select";
import DatePicker from "react-datepicker";
import axios from "axios";
import _ from "lodash";
import { ReportsChart, StatisticCard, StatisticTable } from "./ReportsViews";
import { TwoHeading } from "../../general/TwoHeading";
import Loader3Orange from "../../general/Loader3Orange";
import { FaUser } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";
import { FaMoneyBill, FaUserLock, FaChartLine } from "react-icons/fa";
import { TbArrowsUpDown } from "react-icons/tb";
import { getBrokerageInformation } from "../../store/brokerage";
import { getBrokerInformation, verifyToken } from "../../store/broker";
import moment from "moment";
import translations from "../../utils/translations";
import { capitalizeFirstLetter } from "../../utils/utils";
import { AppBar, Tabs, Tab, Box } from "@material-ui/core";
import ProspectsTab from './ProspectsTab'; 
import PolicyTab from './PolicyTab';
import BrokersTab from './BrokersTab';



const Dashboard = (props) => {
  const dispatch = useDispatch();

  const [currentTab, setCurrentTab] = useState(0); // 0: Brokerage, 1: Prospects, 2: Policy, 3: Brokers
  const [loading, setLoading] = useState(true);
  const [brokerageReportData, setBrokerageReportData] = useState({});
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState("brokers");
  const [tableInfo, setTableInfo] = useState([]);
  const [chartData, setChartData] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [prospectsCharts, setProspectsCharts] = useState();
  const [prospectStatusCharts, setProspectStatusCharts] = useState();
  const [transactionCharts, setTransactionCharts] = useState();
  const [prospectModal, setProspectModal] = useState(false);
  const [bindChart, setBindChart] = useState();
  const [datePickerStart, setDatePickerStart] = useState(
    moment().startOf("month").toDate()
  );
  const [datePickerEnd, setDatePickerEnd] = useState(new Date());
  const [dateRange, setDateRange] = useState([datePickerStart, datePickerEnd]);
  const [startDate, endDate] = dateRange;
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedBroker, setSelectedBroker] = useState("");
  const [dropdownTitle, setDropdownTitle] = useState("This Month");
  const [selectedBusinessSegment, setSelectedBusinessSegment] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [open, setOpen] = useState(true);
  const [detailedView, setDetailedView] = useState(false);
  const brokerInfo = useSelector(getBrokerInformation);
  const languagepreference =
    brokerInfo?.information?.languagepreference || "en";

  // Accessing brokerageAdmin.payment translations
  const translationsDashboard = translations[languagepreference].dashboard;

  const DateCustomInput = forwardRef(({ value, onClick }, ref) => (
    <input
      name="Expiry Date"
      style={{
        // marginLeft: "-25px",
        borderRadius: "5px",
        border: "0",
        width: "100%",
        lineHeight: "30px",
        marginBottom: "6px",
        paddingLeft: "20px",
        paddingRight: "25px",
      }}
      value={value}
      onClick={onClick}
    />
  ));

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const filterDataByDateRange = (data, start, end, path = "createdAt") => {
    if (!start || !end) return data;
    return data.filter((item) => {
      const itemDate = new Date(_.get(item, path));
      if (isNaN(itemDate)) {
        return false;
      }
      return itemDate >= start && itemDate <= end;
    });
  };

  const filterData = (data, matchingItem, path = "status") => {
    if (!matchingItem) return data;
    return data.filter((item) => {
      const itemValue = _.get(item, path);
      if (Array.isArray(matchingItem)) {
        return matchingItem.includes(itemValue);
      }
      return itemValue === matchingItem;
    });
  };

  const getDropdownItems = (data, path = "transactions[0].tostatus") => {
    // Extract statuses
    const statuses = data.map((item) => _.get(item, path));

    // Filter out unique statuses
    const uniqueStatuses = [...new Set(statuses)];

    // Format for react-select
    const formattedStatuses = uniqueStatuses.map((status) => ({
      value: status,
      label: translateStatus(capitalizeFirstLetter(status), languagepreference),
    }));

    return formattedStatuses;
  };

  const prepareChartData = (
    data,
    groupKeyGetter,
    statusField,
    asPercentages = false
  ) => {
    // Sort data by group key
    const sortedData = _.sortBy(data, groupKeyGetter);

    // Group data by group key
    const groupedData = _.groupBy(sortedData, groupKeyGetter);

    // Create labels array (unique group keys)
    const labels = Object.keys(groupedData);

    // Create datasets array
    const datasets = [];
    let totalStatusCount = 0;
    const statusCounts = {};

    for (let groupKey of labels) {
      const counts = _.countBy(groupedData[groupKey], statusField);
      for (let status of Object.keys(counts)) {
        // Ignore statuses with 0 count
        if (counts[status] === 0) {
          continue;
        }

        let dataset = datasets.find((d) => d.label === status);
        if (!dataset) {
          dataset = {
            label: status,
            data: new Array(labels.length).fill(0), // initialize data array with zeros
          };
          datasets.push(dataset);
        }
        dataset.data[labels.indexOf(groupKey)] = counts[status];
        totalStatusCount += counts[status];
        statusCounts[status] = (statusCounts[status] || 0) + counts[status];
      }
    }

    // Convert counts to percentages if required
    if (asPercentages) {
      for (let dataset of datasets) {
        dataset.data = dataset.data.map(
          (count) => (count / totalStatusCount) * 100
        );
      }
    }

    return { labels, datasets };
  };

  useEffect(() => {
    setDateRange([datePickerStart, datePickerEnd]);
  }, [datePickerStart, datePickerEnd]);

  const handleSelect = (eventKey, event) => {
    switch (eventKey) {
      case "1":
        setDatePickerStart(moment().startOf("week").toDate());
        setDatePickerEnd(new Date());
        setDropdownTitle(translationsDashboard.thisWeek);
        break;
      case "2":
        setDatePickerStart(moment().startOf("month").toDate());
        setDatePickerEnd(new Date());
        setDropdownTitle(translationsDashboard.thisMonth);
        break;
      case "3":
        setDatePickerStart(moment().startOf("year").toDate());
        setDatePickerEnd(new Date());
        setDropdownTitle(translationsDashboard.thisYear);
        break;
      case "4":
        setOpen(true);
        break;
      default:
        setDatePickerStart(null);
        setDatePickerEnd(null);
    }
  };

  const prepareChartDataForOneField = (
    data,
    groupKeyGetter,
    label = "Prospects Created"
  ) => {
    // Sort data by group key
    const sortedData = _.sortBy(data, groupKeyGetter);

    // Group data by group key
    const groupedData = _.groupBy(sortedData, groupKeyGetter);

    // Create labels array (unique group keys)
    const labels = Object.keys(groupedData);

    // Create a single dataset containing count per group key
    const dataset = {
      label: label,
      data: labels.map((key) => groupedData[key].length),
      backgroundColor: "blue", // set a fixed color or generate a random color here
    };

    return { labels, datasets: [dataset] };
  };

  function preparePieChartData(list, keyGetter) {
    // Group data by key
    const groupedData = _.groupBy(list, keyGetter);

    // Create labels array (unique keys)
    const labels = Object.keys(groupedData);

    // Create data array (counts of each key)
    const data = labels.map((label) => groupedData[label].length);

    // Create color array (random colors for each key)
    const backgroundColors = labels.map(
      () => "#" + Math.floor(Math.random() * 16777215).toString(16)
    );

    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor: backgroundColors,
        },
      ],
    };
  }

  function prepareInsurerCounts(data, names) {
    const counts = {};

    for (const name of names) {
      counts[name] = 0;
    }

    for (const item of data) {
      for (const name of names) {
        if (item.fromstatus.includes(name)) {
          counts[name]++;
        }
      }
    }

    return names.map((name) => ({
      name,
      amount: counts[name],
    }));
  }

  function prepareInsurerCountsForChart(data, names) {
    const counts = {};

    for (const name of names) {
      counts[name] = 0;
    }

    for (const item of data) {
      for (const name of names) {
        if (item.fromstatus.includes(name)) {
          counts[name]++;
        }
      }
    }

    return {
      labels: names,
      datasets: [
        {
          label: "Insurer Count",
          data: names.map((name) => counts[name]),
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 1,
        },
      ],
    };
  }

  function countLabelsAndBindings(list, labelGetter, isBindedGetter) {
    const groupedData = _.groupBy(list, labelGetter);
    const labels = Object.keys(groupedData);

    return labels.map((label) => {
      const itemsWithLabel = groupedData[label];
      const totalCount = itemsWithLabel.length;
      const bindCount = itemsWithLabel.filter(isBindedGetter).length;

      return {
        vertical: label,
        count: totalCount,
        bindCount,
      };
    });
  }

  const groupKeyGetter = (item, path) => _.get(item, path);
  function joinData(list1, list2, objectName, field1 = "_id", field2 = "_id") {
    return _.map(list1, (item1) => {
      const item1Matches = _.filter(list2, { [field2]: item1[field1] });

      return {
        ...item1,
        [objectName]: item1Matches,
      };
    });
  }
  const broker = useSelector(getBrokerInformation);
  useEffect(() => {
    dispatch(verifyToken());
  }, [dispatch]);

  const statusTranslations = {
    New: {
      fr: "Nouveau",
    },
    "App In Progress": {
      fr: "En cours",
    },
    "Close - Incomplete info": {
      fr: "Fermé - Informations incomplètes",
    },
    "App Completed": {
      fr: "Application terminée",
    },
    "In Market": {
      fr: "Sur le marché",
    },
    "Close - No Insurer": {
      fr: "Fermé - Aucun assureur",
    },
    Quoted: {
      fr: "Devis fourni",
    },
    "Not Interested": {
      fr: "Pas intéressé",
    },
    Sold: {
      fr: "Vendu",
    },
  };

  function translateStatus(status, langPref) {
    if (statusTranslations[status] && statusTranslations[status][langPref]) {
      return statusTranslations[status][langPref];
    } else {
      // Handle cases where the status or language preference is not found
      console.warn(
        `No translation found for status "${status}" and language "${langPref}". Returning original status.`
      );
      return status; // Or you could return a default translation
    }
  }

  useEffect(() => {
    if (!_.isEmpty(broker.information) && broker.information.brokerages) {
      setLoading(true);
      axios
        .post(
          process.env.REACT_APP_BASICSERVICE +
            "/api/brokerages/getBrokerageReport",
          broker.information.brokerages[0],
          {
            headers: { "x-auth-token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          var tempReportData = response.data;

          tempReportData["brokers"] = joinData(
            tempReportData.brokers,
            tempReportData.transactions,
            "transactions",
            "_id",
            "userid"
          );

          tempReportData["prospects"] = joinData(
            tempReportData.prospects,
            tempReportData.transactions,
            "transactions",
            "_id",
            "prospectid"
          );

          tempReportData["prospects"] = joinData(
            tempReportData.prospects,
            tempReportData.brokers,
            "broker",
            "userid",
            "_id"
          );

          tempReportData["prospects"] = joinData(
            tempReportData.prospects,
            tempReportData.binders,
            "binders",
            "_id",
            "prospectid"
          );

          // tempReportData["brokerage"] = joinData(
          //   tempReportData.brokerage,
          //   tempReportData.prospects,
          //   "prospects",
          //   "code",
          //   "brokeragecode"
          // );

          tempReportData["prospects"] = joinData(
            tempReportData.prospects,
            tempReportData.response,
            "quotes",
            "_id",
            "prospectid"
          );
          var soldProspects = tempReportData.prospects.filter(
            (item) => item.status === "Sold"
          );
          tempReportData["prospects"] = tempReportData.prospects.filter(
            (item) => item.createdAt
          );

          // console.log("show me data filter tempReportData", createdAtamt);

          const tempCard = [
            {
              icon: FaUser,
              title: translationsDashboard.brokers,
              data: tempReportData.brokers.length,
              view: "brokers",
            },
            {
              icon: TbArrowsUpDown,
              title: translationsDashboard.transactions,
              data: tempReportData.transactions.length,
              view: "transactions",
            },
            {
              icon: FaUserFriends,
              title: translationsDashboard.prospects,
              data: tempReportData.prospects.length,
              view: "prospects",
            },
            {
              icon: FaChartLine,
              title: translationsDashboard.sales,
              data: soldProspects.length,
              view: "binders",
            },
          ];

          setCards(tempCard);
          setBrokerageReportData(tempReportData);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error:", error);
        });
    }
  }, [broker]);

  useEffect(() => {
    const groupKeyGetterProspects = (item) =>
      _.get(
        item,
        "answers.operations.list[0].vertical.name." + languagepreference
      );

    if (brokerageReportData.prospects) {
      const filterConfigurations = [
        {
          data: brokerageReportData.prospects,
          matchingItem: startDate,
          path: "transactions[0].usertime",
          type: "date",
          startDate: startDate,
          endDate: endDate,
        },
        {
          matchingItem: selectedStatus,
          path: "status",
        },
        {
          matchingItem: selectedBroker,
          path: "broker[0].firstname",
        },
        {
          matchingItem: selectedBusinessSegment,
          path:
            "answers.operations.list[0].vertical.name." + languagepreference,
        },
      ];

      const tempFilteredData = filterConfigurations.reduce((data, config) => {
        if (config.type === "date") {
          return filterDataByDateRange(
            data,
            config.startDate,
            config.endDate,
            config.path
          );
        } else {
          return filterData(data, config.matchingItem, config.path);
        }
      }, filterConfigurations[0].data);

      setFilteredData(tempFilteredData);
      setProspectsCharts(
        preparePieChartData(tempFilteredData, groupKeyGetterProspects)
      );
    }
  }, [
    selectedStatus,
    startDate,
    selectedBroker,
    selectedBusinessSegment,
    endDate,
    brokerageReportData,
  ]);
  // custom input for date picker
  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div onClick={onClick} ref={ref}>
      <Dropdown.ItemText>{translationsDashboard.custom}</Dropdown.ItemText>
    </div>
  ));
  useEffect(() => {
    if (brokerageReportData.transactions)
      var temp = brokerageReportData.transactions.filter(
        (item) => item.tostatus === "Bind Request"
      );
  }, [brokerageReportData]);
  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      ) : (
        <>
          <Row style={{ width: "101vw", height: "100%", }}>
            <Col
              md={10}
              style={{
                boxShadow: "rgb(175, 182, 204) 20px 20px 30px 0px ",
                zIndex: "2",
                overflow: "auto",
                // maxHeight: "99vh",
                // minWidth: "100%",

                height: "100%",
              }}
            >
              <AppBar position="static" color="default" style={{boxShadow: 'none', background: 'transparent'}}>
                <Tabs
                  value={currentTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                >
                  <Tab label="Brokerage" />
                  <Tab label="Prospects" />
                  <Tab label="Policy" />
                  <Tab label="Brokers" />
                </Tabs>
              </AppBar>

              {/* Brokerage Tab Content */}
              {currentTab === 0 && (
                <>
                  <div style={{ padding: "20px" }}>
                    <TwoHeading
                      heading1={translationsDashboard.yourDashboard}
                      //   heading2={"Placeholder"}
                    ></TwoHeading>
                  </div>
                  {!_.isEmpty(filteredData) && (
                    <Row style={{ padding: "20px", height: "20%" }}>
                      <>
                        <Col md={12} style={{ padding: "20px" }}>
                          <Row>
                            <Col>
                              <div className="chartTitle">
                                <div> </div>
                                {translationsDashboard.summary}
                                <div> </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                {cards.map((cardInfo) => {
                                  return (
                                    <StatisticCard
                                      cardInfo={cardInfo}
                                      // selectedCard={selectedCard}
                                      setSelectedCard={(card) =>
                                        setSelectedCard(card)
                                      }
                                    />
                                  );
                                })}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          md={6}
                          style={{ padding: "20px" }}
                          // className="d-flex justify-content-center"
                        >
                          <div className="chartTitle">
                            <div> </div>
                            {translationsDashboard.businessSegments}

                            <div> </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <ReportsChart
                              maintainAspectRatio={true}
                              reportData={prospectsCharts}
                              reportChartType="PIE"
                              reportTitle="BUSINESS SEGMENT OVER SELECTED TIME PERIOD"
                            />
                          </div>
                        </Col>
                        <Col md={6} style={{ padding: "20px" }}>
                          <div className="chartTitle">
                            <div> </div>
                            {translationsDashboard.currentProspectStatus}

                            <div> </div>
                          </div>
                          <ReportsChart
                            legend={false}
                            reportData={prepareChartDataForOneField(
                              filteredData,
                              (item) => _.get(item, "status")
                            )}
                            reportChartType="BAR"
                            // reportTitle="CURRENT PROSPECT STATUS"
                          />
                        </Col>
                        <Col md={6} style={{ marginTop: "20px" }}>
                          {/* /binder to vertical */}
                          <div className="chartTitle">
                            <div> </div>
                            {translationsDashboard.salesAnalysisByVertical}

                            <div> </div>
                          </div>
                          <ReportsChart
                            reportData={prepareChartData(
                              filteredData,
                              (item) => {
                                const date = new Date(
                                  _.get(item, "createdAt")
                                );
                                return date.toLocaleDateString();
                              }, // Convert to a string in the format 'MM/DD/YYYY' _.get(item, "binders[0].createdAt")}
                              "answers.operations.list[0].vertical.name." +
                                languagepreference
                            )}
                            reportChartType="BAR"
                            // reportTitle="SALES ANALYSIS BY VERTICAL"
                            isStacked={true}
                          />
                        </Col>

                        <Col md={6} style={{ marginTop: "20px" }}>
                          <div className="chartTitle">
                            <div> </div>
                            {translationsDashboard.salesAnalysisByBroker}

                            <div> </div>
                          </div>
                          <ReportsChart
                            reportData={prepareChartData(
                              filteredData,
                              (item) => {
                                const date = new Date(
                                  _.get(item, "createdAt")
                                );
                                return date.toLocaleDateString();
                              }, // Convert to a string in the format 'MM/DD/YYYY' _.get(item, "binders[0].createdAt")}
                              "broker[0].firstname"
                            )}
                            reportChartType="BAR"
                            // reportTitle="Sales Analysis By Broker"
                            isStacked={true}
                          />
                        </Col>
                        <Col md={6} style={{ marginTop: "20px" }}>
                          <div className="chartTitle">
                            <div></div>
                            {detailedView
                              ? translationsDashboard.prospectsAddedBySegment
                              : translationsDashboard.addedProspects}
                            <div>
                              {detailedView ? (
                                <ZoomOut
                                  fontSize="large"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setDetailedView(false)}
                                />
                              ) : (
                                <ZoomIn
                                  fontSize="large"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setDetailedView(true)}
                                />
                              )}
                            </div>
                          </div>
                          {detailedView ? (
                            <ReportsChart
                              reportData={prepareChartData(
                                filteredData,
                                (item) => {
                                  const date = new Date(
                                    _.get(item, "transactions[0].usertime")
                                  );
                                  return date.toLocaleDateString();
                                },
                                "answers.operations.list[0].vertical.name." +
                                  languagepreference
                              )}
                              reportChartType="BAR"
                              isStacked={true}
                            />
                          ) : (
                            <ReportsChart
                              reportData={prepareChartDataForOneField(
                                filteredData,
                                (item) => {
                                  const date = new Date(
                                    _.get(item, "transactions[0].usertime")
                                  );
                                  return date.toLocaleDateString();
                                }
                              )}
                              reportChartType="BAR"
                              isStacked={true}
                            />
                          )}
                        </Col>
                        <Col md={6} style={{ marginTop: "20px" }}>
                          <div className="chartTitle">
                            <div></div>
                            {translationsDashboard.keyPipelineRatios}
                            <div></div>
                          </div>
                          <ReportsChart
                            reportData={prepareChartData(
                              filteredData,
                              (item) => {
                                const date = new Date(
                                  _.get(item, "transactions[0].usertime")
                                );
                                return date.toLocaleDateString();
                              },
                              "status",
                              true // This will return percentages instead of counts
                            )}
                            reportChartType="LINE" // Switch to a line chart
                            // reportTitle="Status Ratios Over Time"
                            isStacked={false}
                            maintainAspectRatio={true}
                            isPercentage={true}
                          />
                        </Col>
                        <Col
                          md={6}
                          style={{ marginTop: "20px",paddingBottom:"41px" }}
                          // className="d-flex justify-content-center"
                        >
                          <div className="chartTitle">
                            <div></div>
                            {translationsDashboard.salesFunnel}
                            <div></div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <ReportsChart
                              reportData={preparePieChartData(
                                filteredData,
                                (prospect) => {
                                  if (prospect.isbinded) {
                                    return translationsDashboard.status_sold;
                                  }
                                  if (
                                    prospect.quotes &&
                                    prospect.quotes.length > 0
                                  ) {
                                    return translationsDashboard.status_quoted;
                                  }
                                  if (prospect.status === "new") {
                                    return translationsDashboard.status_nurture;
                                  }
                                  if (prospect.status === "closed") {
                                    return translationsDashboard.status_bad_lead;
                                  }
                                }
                              )}
                              reportChartType="PIE" // Switch to a line chart
                              // reportTitle="SALES FUNNEL"
                              isStacked={false}
                              maintainAspectRatio={true}
                              isPercentage={false}
                            />
                          </div>
                        </Col>
                      </>
                    </Row>
                  )}
                  {_.isEmpty(filteredData) && (
                    <Col
                      md={12}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div>
                        <img
                          width={"400px"}
                          src="https://error404.fun/img/illustrations/08.png"
                        />
                      </div>
                      <div>
                        <h3
                          style={{
                            fontFamily: "GibsonSemiBd",
                            color: "rgb(63, 68, 90)",
                          }}
                        >
                          {translationsDashboard.noDataFound}
                        </h3>
                      </div>
                      <div>
                        <h3
                          style={{
                            fontFamily: "GibsonSemiBd",
                            color: "rgb(63, 68, 90)",
                          }}
                        >
                          {moment(startDate).format("LL")} -{" "}
                          {moment(endDate).format("LL")}
                        </h3>
                      </div>
                    </Col>
                  )}
                </>
              )}

              {/* Other Tab Content */}
              {currentTab === 1 &&  <ProspectsTab 
                                    brokerInfo={brokerInfo}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectedStatus={selectedStatus}
                                    selectedBroker={selectedBroker}
                                    selectedBusinessSegment={selectedBusinessSegment}
                                    translationsDashboard={translationsDashboard}
                                />}
              {currentTab === 2 && <PolicyTab 
                                    brokerInfo={brokerInfo}
                                    startDate={startDate}
                                    endDate={endDate}
                                    // Pass any other relevant filters if needed
                                    translationsDashboard={translationsDashboard}
                                />}
              {currentTab === 3 &&  <BrokersTab 
                                    brokerInfo={brokerInfo}
                                    startDate={startDate}
                                    endDate={endDate}
                                    translationsDashboard={translationsDashboard}
                                />}
            </Col>

            <Col
              md={2}
              style={{
                maxHeight: "99vh",
                width: "101vw",
                background: "rgb(214, 218, 231)",
                overflow: "hidden",
              }}
            >
              {!_.isEmpty(brokerageReportData) && (
                <div
                  style={{
                    // width: "100%",
                    // height: "100%",
                    padding: "19px",
                    // justifyContent: "center",
                    // alignItems: "center",
                    fontFamily: "GibsonLight",
                    color: "grey",
                    maxHeight: "99vh",
                    minWidth: "100%",
                  }}
                >
                  <div>
                    <Typography
                      variant="h5"
                      component="h5"
                      style={{
                        fontFamily: "GibsonSemiBd",
                        fontSize: 26,
                        color: theme.COLORS.primary_navyblue,
                      }}
                    >
                      {translationsDashboard.filters}
                    </Typography>
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <Typography
                      variant="h5"
                      component="h5"
                      style={{
                        fontFamily: "GibsonSemiBd",
                        fontSize: 20,
                        color: theme.COLORS.secondary_orange,
                      }}
                    >
                      {translationsDashboard.date}
                    </Typography>
                    <div>
                      <Dropdown
                        className="bindModal"
                        style={{ width: "100%" }}
                        onSelect={handleSelect}
                      >
                        <Dropdown.Toggle variant="light" id="dropdown-basic">
                          {dropdownTitle}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item eventKey="1">
                            {translationsDashboard.thisWeek}
                          </Dropdown.Item>
                          <Dropdown.Item eventKey="2">
                            {translationsDashboard.thisMonth}
                          </Dropdown.Item>
                          <Dropdown.Item eventKey="3">
                            {translationsDashboard.custom}
                          </Dropdown.Item>
                          {
                            <DatePicker
                              selectsRange={true}
                              startDate={dateRange[0]}
                              endDate={dateRange[1]}
                              maxDate={new Date()}
                              onChange={(update) => {
                                setDatePickerStart(update[0]);
                                setDatePickerEnd(update[1]);
                                setDropdownTitle(
                                  `${moment(update[0]).format(
                                    "MM/DD/YYYY"
                                  )} - ${moment(update[1]).format(
                                    "MM/DD/YYYY"
                                  )}`
                                );
                                setOpen(false);
                              }}
                              isClearable={true}
                              customInput={<CustomInput />}
                            />
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                      {dropdownTitle === "Custom" && (
                        <DatePicker
                          selectsRange={true}
                          startDate={dateRange[0]}
                          endDate={dateRange[1]}
                          onChange={(update) => {
                            setDatePickerStart(update[0]);
                            setDatePickerEnd(update[1]);
                          }}
                          isClearable={true}
                          customInput={<CustomInput />}
                        />
                      )}
                    </div>
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <Typography
                      variant="h5"
                      component="h5"
                      style={{
                        fontFamily: "GibsonSemiBd",
                        fontSize: 20,
                        color: theme.COLORS.secondary_orange,
                      }}
                    >
                      {translationsDashboard.status}
                    </Typography>

                    <div>
                      <Select
                        placeholder={translationsDashboard.select}
                        isMulti
                        isClearable={true}
                        options={getDropdownItems(
                          brokerageReportData.prospects,
                          "status"
                        )}
                        onChange={(selectedOption) => {
                          if (selectedOption && !_.isEmpty(selectedOption)) {
                            setSelectedStatus(
                              selectedOption.map((option) => option.value)
                            );
                          } else {
                            setSelectedStatus("");
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <Typography
                      variant="h5"
                      component="h5"
                      style={{
                        fontFamily: "GibsonSemiBd",
                        fontSize: 20,
                        color: theme.COLORS.secondary_orange,
                      }}
                    >
                      {translationsDashboard.vertical}
                    </Typography>
                    <div>
                      <Select
                        placeholder={translationsDashboard.select}
                        isClearable={true}
                        isMulti
                        options={getDropdownItems(
                          brokerageReportData.prospects,
                          "answers.operations.list[0].vertical.name." +
                            languagepreference
                        )}
                        onChange={(selectedOption) => {
                          if (selectedOption && !_.isEmpty(selectedOption)) {
                            setSelectedBusinessSegment(
                              selectedOption.map((option) => option.value)
                            );
                          } else {
                            setSelectedBusinessSegment("");
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <Typography
                      variant="h5"
                      component="h5"
                      style={{
                        fontFamily: "GibsonSemiBd",
                        fontSize: 20,
                        color: theme.COLORS.secondary_orange,
                      }}
                    >
                      {translationsDashboard.broker}
                    </Typography>
                    <div>
                      <Select
                        placeholder={translationsDashboard.select}
                        isMulti
                        isClearable={true}
                        options={getDropdownItems(
                          brokerageReportData.prospects,
                          "broker[0].firstname"
                        )}
                        onChange={(selectedOption) => {
                          if (selectedOption && !_.isEmpty(selectedOption)) {
                            setSelectedBroker(
                              selectedOption.map((option) => option.value)
                            );
                          } else {
                            setSelectedBroker("");
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <OrangeButton
                      text={translationsDashboard.clearFilters}
                      width="12.5vw"
                      onClick={(e) => {
                        setSelectedBroker("");
                        setSelectedStatus("");
                        setSelectedBusinessSegment("");
                      }}
                    />
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default Dashboard;